// export layout related constants
export const LAYOUT_VERTICAL = 'vertical';

export const LAYOUT_HORIZONTAL = 'horizontal';

export const LAYOUT_MODE = 'light';

export const LAYOUT_WIDTH = 'fluid';

export const LAYOUT_POSITION = 'fixed';

export const TOPBAR = 'light';

export const SIDEBAR_SIZE = 'default';

export const SIDEBAR_COLOR = 'dark';
